import React from 'react';
import NodeSymbolSelect from './NodeSymbolSelect';
import { Handle, Position } from 'reactflow';

const boxStyle = {
  padding: 12, borderRadius: 8, border: '2px solid #ca8a04',
  background: 'var(--card)', minWidth: 220, fontSize: 13, color: 'var(--text)',
};
const selStyle = {
  width: '100%', marginBottom: 6, padding: 4, background: 'var(--surface)',
  color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4,
};

export default function RoundLevelNode({ data, id }) {
  const onChange = (field, value) => {
    if (data.onChange) data.onChange(id, field, value);
  };
  const mode = data.mode || 'above';
  const isBreak = mode === 'break_up' || mode === 'break_down';
  return (
    <div style={boxStyle}>
      <div style={{ fontWeight: 700, marginBottom: 8, color: '#eab308' }}>🔢 Round Level</div>
      <NodeSymbolSelect value={data.symbol} onChange={(v) => onChange('symbol', v)} />

      <label style={{ fontSize: 11, color: 'var(--muted)' }}>Step (grid size)</label>
      <input
        type="number" min={0.0001} step="any" value={data.step ?? 100}
        onChange={(e) => onChange('step', parseFloat(e.target.value) || 100)}
        style={selStyle}
      />

      <select value={mode} onChange={(e) => onChange('mode', e.target.value)} style={selStyle}>
        <option value="above">Nearest level above (price)</option>
        <option value="below">Nearest level below (price)</option>
        <option value="nearest">Nearest level (price)</option>
        <option value="near">Price near a level (1/0)</option>
        <option value="break_up">Breaks up through a level (1/0)</option>
        <option value="break_down">Breaks down through a level (1/0)</option>
      </select>

      {mode === 'near' && (
        <>
          <label style={{ fontSize: 11, color: 'var(--muted)' }}>Tolerance (price)</label>
          <input type="number" min={0} step="any" value={data.tolerance ?? 0}
            onChange={(e) => onChange('tolerance', parseFloat(e.target.value) || 0)} style={selStyle} />
        </>
      )}
      {isBreak && (
        <>
          <label style={{ fontSize: 11, color: 'var(--muted)' }}>Buffer beyond level (price)</label>
          <input type="number" min={0} step="any" value={data.buffer ?? 0}
            onChange={(e) => onChange('buffer', parseFloat(e.target.value) || 0)} style={selStyle} />
        </>
      )}

      <div style={{ marginTop: 2, fontSize: 10, color: 'var(--muted)' }}>
        {isBreak
          ? 'Round-number breakout — outputs 1 the bar price breaks through a level. Compare with value 1.'
          : mode === 'near'
            ? 'Outputs 1 when price is within tolerance of a round level.'
            : 'Outputs a round-number price level — compare it against price.'}
      </div>

      <Handle type="source" position={Position.Right} id="output" style={{ background: '#ca8a04' }} />
    </div>
  );
}
